<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
import { DEFAULT_TITLE } from '../../../utils/constants';
import { SideBar } from '@/core/config/menu/sideBar';
import { SET_MENU } from '@/core/services/store/modules/menu.module';

export default {
  name: 'VehiclePurchaseOrder',
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || DEFAULT_TITLE;
        // Báo cáo công nợ NPP nằm trong nhóm Kế toán → giữ sidebar Kế toán;
        // các màn còn lại (list/tạo/sửa/chi tiết) thuộc nhóm Kho.
        const isDebtReport = to.name === 'po-supplier-debt-report';
        this.$store.dispatch(
          SET_MENU,
          isDebtReport ? SideBar.ACCOUNTANT : SideBar.STOCK,
        );
      },
    },
  },
};
</script>
